import React, { FC } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    makeStyles,
    createStyles,
    IconButton,
    TableContainer
} from '@material-ui/core'

import { Edit as EditIcon, Delete as DeleteIcon } from '@material-ui/icons'
import { CourierDto } from './DTO/CourierDto'
import { Pagination, PaginationProps } from '../../components/Pagination'

interface Props extends PaginationProps {
    data?: CourierDto[]
    onEdit?: (id: number) => void
    onDelete?: (id: number) => void
}

export const CourierTable: FC<Props> = ({
    data = [],
    onEdit,
    pagination,
    onPaginationChange,
    onDelete
}) => {
    const styles = useStyles()

  
    return (        
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align='center'>Código</TableCell>
                        <TableCell align='center'>Nombre</TableCell>
                        <TableCell align='center'>Estado</TableCell>
                        <TableCell align='center'>Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        data.map(item => {
                            return (
                                <TableRow key={item.courierId}>
                                    <TableCell align='center'>{item.courierCode}</TableCell>
                                    <TableCell align='center'>{item.name}</TableCell>
                                    <TableCell align='center'>{item.active ? 'Activo' : 'Inactivo'}</TableCell>
                                    <TableCell align='center'>
                                        <div className={styles.action}>
                                            <IconButton onClick={() => onEdit && onEdit(item.courierId)}>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton  aria-label='delete' onClick={() => onDelete && onDelete(item.courierId)}>                                                    
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
            <Pagination pagination={pagination} onPaginationChange={onPaginationChange}/>
        </TableContainer>
    )
}

const useStyles = makeStyles(
    createStyles({
        action: {
            display: 'inline-block',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
        }
    })
)

